import { LevelPlayFile as Activity } from '.'

export const SLUG = 'file'
export const activity = {
  SLUG,
  interactionMode: {
    kind: 'continue',
    waitValidation: false
  },
  Component: Activity
}
